export const composeArrayKeysToObject = (arr: string[], value) => {
    let object = arr.reduce((ac,a) => ({
        ...ac,
        [a]: value
    }), {});

    return object;
};
